export const getNikName = (firstname, lastname) => {
  if (firstname && lastname) {
    return firstname?.toUpperCase().substring(0, 1) + lastname?.toUpperCase().substring(0, 1);
  }
  return undefined;
};
